import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { useContext } from 'react'
import { GuestsDataContext } from 'components/common/MarchPromo/utils/guestsDataProvider'
import Price from 'components/shared/Price'
import { FormattedMessage } from 'react-intl'
import Loader from 'components/shared/Loader'

const GuestsTotalPrice = () => {
    const { totalPrice } = useContext(GuestsDataContext)

    return (
        <Box
            direction="row"
            align="baseline"
            justify={['flex-end', 'flex-start']}
        >
            {!totalPrice ? (
                <Loader />
            ) : (
                <>
                    <Text
                        variant="body14"
                        color="secondary_500"
                        mr={4}
                        mt={[8, 12]}
                    >
                        <FormattedMessage
                            id="global.price.label_total"
                            defaultMessage="_"
                        />
                        :
                    </Text>
                    <Price
                        value={totalPrice}
                        size="heading2"
                        currencySize="body16Strong"
                    />
                </>
            )}
        </Box>
    )
}

export default GuestsTotalPrice
